import React from "react"
import { useTranslation } from "react-i18next"
import { Bike } from "models"
import { BikeRow } from "./BikeRow"

export type BikesArrayProps = {
	bikesList: Bike[]
	className?: string
}

export const BikeTable: React.FC<BikesArrayProps> = ({ bikesList, className }) => {
	const { t } = useTranslation()

	const hasBikes = bikesList.length > 0

	if (!hasBikes) {
		return (
			<div className="w-full text-m pt-4 pb-8 text-center font-bold">
				{t("dashboard.no_bikes", { ns: "bike" })}
			</div>
		)
	}

	return (
		<table className={`c-table ${className}`}>
			<thead>
				<tr className="c-table__head-4">
					<th className="py-5 px-3 rounded-l-base">
						{t("description.status", { ns: "bike" })}
					</th>
					<th className="py-5 px-3">{t("description.bike_name", { ns: "bike" })}</th>
					<th className="py-5 px-3">{t("description.fnuci_code", { ns: "bike" })}</th>
					<th className="py-5 px-3">{t("description.action", { ns: "bike" })}</th>
				</tr>
			</thead>

			<tbody>
				{
					// prettier-ignore
					hasBikes &&
						bikesList.map((bike: Bike, index: number) => (
						<BikeRow bike={bike} key={index} />
						))
				}
			</tbody>
		</table>
	)
}
